import { Box} from '@mui/material'
import React, { useMemo } from 'react';
import ResponsiveNav from '../components/navigation/navigation';
import OrderHistoryTable from '../components/OrderHistoryTable/OrderHistoryTable';
// import GiftSubHero from '../components/SubHero/SubHero';
import MoreItems from '../components/MoreItems/MoreItems';
import HistoryHeader from '../components/HistoryHead.erjsx/HistoryHeader';
import { useNavigate } from 'react-router-dom';
import { useGet } from '../hooks/useApi';

const GiftsOrderHistory = () => {
  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);  // This is how you handle navigation back
  };

      const { 
        data: giftData, 
        
      } = useGet('/api/GiftItems/get-all-gift-Items');
  const giftItems = useMemo(() => giftData?.data || [], [giftData]);
  const MoreGiftsData = giftItems?.filter((item)=>item?.categoryName.toLowerCase().includes('for him'));
  console.log(MoreGiftsData)
  const customerId = sessionStorage.getItem('userId');
  
  const { data: giftOrderHistory } = useGet(`/api/GiftItemOrders/order-history?userEmail=${customerId}`);

  const giftOrderItems = useMemo(() => giftOrderHistory?.data || [], [giftOrderHistory]);
  console.log(giftOrderItems)
  
  const breadcrumbItems = [
    { label: 'Home', link: '/' },
    { label: 'Product Details', link:goBack },
    { label: 'Buy List', link: '/product/giftshop/order-history' },
  ];
      
  return (
    <Box>
        <ResponsiveNav breadcrumbItems={breadcrumbItems} searchValue="" onSearchChange={() => {}} searchPlaceholder="Search..." />
        <HistoryHeader/>
        <OrderHistoryTable order_data={giftOrderItems}/>
        {/* <GiftSubHero/> */}
        <MoreItems title={`Gift ${'For Him'}`} moreItems={MoreGiftsData}/>
    </Box>
  )
}

export default GiftsOrderHistory